import { useModal, Modals } from "../../contexts/ModalContext"
import {
  ModalContainer
} from "./Modal.styles";
import { ModalContent } from "./ModalContent";
import { useTheme } from "@mui/material/styles";
import { Variants } from "./Modal.variants";

export const Modal = () => {
  const { modalState, closeModal, modalBookingData, modalOnClick } = useModal();
  const theme = useTheme();
  const variantStylesFn = Variants(theme);
  let currentVariant;
  let modalContentType;
  let closeOnBackdropClick = true;

  switch (modalState) {
    case Modals.None:
      modalContentType = <ModalContent.None />;
      currentVariant = variantStylesFn["None"]
      break;
    case Modals.TermsHighlight:
      modalContentType = <ModalContent.TermsHighlight closeModal={closeModal} onClick={modalOnClick} />;
      currentVariant = variantStylesFn["TermsHighlight"]
      closeOnBackdropClick = false;
      break;
    case Modals.NonPrioritySessionSelected:
      modalContentType = <ModalContent.NonPrioritySessionSelected closeModal={closeModal} onClick={modalOnClick} />;
      currentVariant = variantStylesFn["NonPrioritySessionSelected"]
      break;
    case Modals.PriorityTicketsFullyBooked:
      modalContentType = <ModalContent.PriorityTicketsFullyBooked closeModal={closeModal} onClick={modalOnClick} />;
      currentVariant = variantStylesFn["PriorityTicketsFullyBooked"]
      closeOnBackdropClick = false;
      break;
    case Modals.NotEnoughPriorityTickets:
      modalContentType = <ModalContent.NotEnoughPriorityTickets closeModal={closeModal} onClick={modalOnClick} />;
      currentVariant = variantStylesFn["NotEnoughPriorityTickets"]
      break;
    case Modals.DeleteAccount:
      modalContentType = <ModalContent.DeleteAccount closeModal={closeModal} />;
      currentVariant = variantStylesFn["DeleteAccount"]
      break;
    case Modals.DeactivateAccount:
      modalContentType = <ModalContent.DeactivateAccount closeModal={closeModal} />;
      currentVariant = variantStylesFn["DeactivateAccount"]
      break;
    case Modals.ReactivateAccount:
      modalContentType = <ModalContent.ReactivateAccount closeModal={closeModal} />;
      currentVariant = variantStylesFn["ReactivateAccount"]
      break;
    case Modals.ResetPassword:
      modalContentType = <ModalContent.ResetPassword closeModal={closeModal} />;
      currentVariant = variantStylesFn["ResetPassword"]
      break;
    case Modals.EditGuestDetails:
      modalContentType = <ModalContent.EditGuestDetails closeModal={closeModal} modalBookingData={modalBookingData} onClick={modalOnClick} />;
      currentVariant = variantStylesFn["EditGuestDetails"]
      break;
    case Modals.RemoveTickets:
      modalContentType = <ModalContent.RemoveTickets closeModal={closeModal} modalBookingData={modalBookingData} onClick={modalOnClick} />;
      currentVariant = variantStylesFn["RemoveTickets"]
      break;
    case Modals.AcceptTicket:
      modalContentType = <ModalContent.AcceptTicket closeModal={closeModal} onClick={modalOnClick} />;
      currentVariant = variantStylesFn["AcceptTicket"]
      break;
    case Modals.DeclineTicket:
      modalContentType = <ModalContent.DeclineTicket closeModal={closeModal} onClick={modalOnClick} />;
      currentVariant = variantStylesFn["DeclineTicket"]
      break;
    case Modals.SaveProgress:
      modalContentType = <ModalContent.SaveProgress closeModal={closeModal} onClick={modalOnClick} />;
      currentVariant = variantStylesFn["SaveProgress"]
      break;
    case Modals.AccessibilityRequirementsChange:
      modalContentType = <ModalContent.AccessibilityRequirementsChange closeModal={closeModal} onClick={modalOnClick} />
      currentVariant = variantStylesFn["AccessibilityRequirementsChange"]
      break;
    case Modals.AllocationAccessibilityRequirementsAdded:
      modalContentType = <ModalContent.AllocationAccessibilityRequirementsAdded closeModal={closeModal} onClick={modalOnClick} />
      currentVariant = variantStylesFn["AllocationAccessibilityRequirementsAdded"]
      break;
    case Modals.AllocationAccessibilityRequirementsRemoved:
      modalContentType = <ModalContent.AllocationAccessibilityRequirementsRemoved closeModal={closeModal} onClick={modalOnClick} />
      currentVariant = variantStylesFn["AllocationAccessibilityRequirementsRemoved"]
      break;
    case Modals.AllocationUpdatedAge:
      modalContentType = <ModalContent.AllocationUpdatedAge closeModal={closeModal} onClick={modalOnClick} />
      currentVariant = variantStylesFn["AllocationUpdatedAge"]
      break;
    default:
      modalContentType = <ModalContent.None />;
      currentVariant = variantStylesFn["None"]
      break;
  }


  return (
    <ModalContainer
      data-cy="modal-container"
      PaperProps={{ elevation: 0 }}
      open={modalState != Modals.None}
      sx={{ ...currentVariant }}
      onClose={closeOnBackdropClick ? closeModal : undefined}
    >
      {modalContentType}
    </ModalContainer>
  );
};

Modal.displayName = "Modal";
